import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { UpdateSmartLabSettingsRequest } from '@/lib/api/smartlab-settings-api'
import { smartLabSettingsApi } from '@/lib/api/smartlab-settings-api'
import { m } from '@/lib/paraglide/messages'

export const smartLabSettingsKeys = {
    all: ['smartlab-settings'] as const,
}

export function useSmartLabSettings() {
    return useQuery({
        queryKey: smartLabSettingsKeys.all,
        queryFn: async () => {
            const res = await smartLabSettingsApi.get()
            return res.data ?? null
        },
    })
}

export function useUpdateSmartLabSettings() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: async (data: UpdateSmartLabSettingsRequest) => {
            const res = await smartLabSettingsApi.update(data)
            return res.data
        },
        onSuccess: () => {
            void qc.invalidateQueries({ queryKey: smartLabSettingsKeys.all })
            toast.success(m.smartlab_settings_save_success())
        },
        onError: () => toast.error(m.smartlab_settings_save_error()),
    })
}
